export const ERROR = 'API/ERROR'
export const ERROR_500 = 'API/ERROR_500'
export const FETCH_DATA = 'API/FETCH_DATA'
export const LOADING = 'LOADING'
export const ERRORS = 'ERRORS'
